<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="用户/师傅id,外键{zb_user.id}" prop="userId" >
        <a-input v-model="form.userId" placeholder="请输入用户/师傅id,外键{zb_user.id}" />
      </a-form-model-item>
      <a-form-model-item label="师傅订单id,外键{zb_master_order.id}" prop="masterOrderId" >
        <a-input v-model="form.masterOrderId" placeholder="请输入师傅订单id,外键{zb_master_order.id}" />
      </a-form-model-item>
      <a-form-model-item label="处理类型,0-发起售后 1-联系客户,1-售后完成" prop="read" >
        <a-input v-model="form.read" placeholder="请输入处理类型,0-发起售后 1-联系客户,1-售后完成" />
      </a-form-model-item>
      <a-form-model-item label="轮次" prop="alternately" >
        <a-input v-model="form.alternately" placeholder="请输入轮次" />
      </a-form-model-item>
      <a-form-model-item label="售后原因" prop="reason" >
        <a-input v-model="form.reason" placeholder="请输入售后原因" />
      </a-form-model-item>
      <a-form-model-item label="凭证/说明" prop="proof" >
        <a-input v-model="form.proof" placeholder="请输入凭证/说明" />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="picture" >
        <a-input v-model="form.picture" placeholder="请输入图片" />
      </a-form-model-item>
      <a-form-model-item label="备注" prop="remark" >
        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import {addAfter, getAfter, updateAfter} from '@/api/order/after'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,

        userId: null,

        masterOrderId: null,

        read: null,

        alternately: null,

        reason: null,

        proof: null,

        picture: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        userId: [
          { required: true, message: '用户/师傅id,外键{zb_user.id}不能为空', trigger: 'blur' }
        ],
        masterOrderId: [
          { required: true, message: '师傅订单id,外键{zb_master_order.id}不能为空', trigger: 'blur' }
        ],
        read: [
          { required: true, message: '处理类型,0-发起售后 1-联系客户,1-售后完成不能为空', trigger: 'blur' }
        ],
        alternately: [
          { required: true, message: '轮次不能为空', trigger: 'blur' }
        ],
        reason: [
          { required: true, message: '售后原因不能为空', trigger: 'blur' }
        ],
        proof: [
          { required: true, message: '凭证/说明不能为空', trigger: 'blur' }
        ],
        picture: [
          { required: true, message: '图片不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        masterOrderId: null,
        read: null,
        alternately: null,
        reason: null,
        proof: null,
        picture: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAfter({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAfter(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAfter(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
